/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";

import { useNavigate, useParams } from "react-router-dom";

import { useDispatch, useSelector } from "react-redux";

import TransactionLimit from "../../../../components/FieldForceAccount/FieldForceAccountCreate/FieldForceContactDetails/TransactionLimit";
import AccountName from "../../../../components/_utils/AccountCreationComponents/AccountName";
import ContactDetails from "../../../../components/_utils/AccountCreationComponents/ContactDetails";
import SmallPopup from "../../../../components/_utils/CommonSmallPopup";
import PrimaryStepper from "../../../../components/_utils/CommonSteppers/PrimaryStepper";
import TopNavComponent from "../../../../components/_utils/CommonTopNav/TopNavComponent";
import { editBeneficiary } from "../../../../redux/features/accounts/BeneficiaryAccount/createAccount";
import { viewAccountDetail } from "../../../../redux/features/verifyPAN/verifyPAN";
import { GlobalConfiguration } from "../../../../utils/configurationProvider";
import TEXT from "../../../../utils/globalText";
import Validation from "../../../../utils/validation";
import LinkEntityCard from "../../../../components/_utils/LinkEntityCard";

const FieldForceEditContact = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [customErrors, setCustomErrors] = useState({});
  const [selectedValue, setSelectedValue] = useState("");
  const [emailValidation, setEmailValidation] = useState(false);
  const [nextButtonEnabled, setNextButtonEnabled] = useState(false);
  const [openEditContactPop, setOpenEditContactPop] = useState(false);
  const [accountNameValidation, setAccountNameValidation] = useState(true);
  const [contactNumberValidation, setContactNumberValidation] = useState(false);
  const [selectedValueAmount, setSelectedValueAmount] =
    useState("defaultAmount");
  const [selectedRadioValue, setSelectedRadioValue] = useState("customname");
  const [payload, setPayload] = useState({
    contact_no: "",
    email_id: "",
    account_name: "",
    legalName: "",
    userName: "Get from get specific API",
    userId: "Comes from API",
    amount: 10000,
  });

  const { viewAccountDetailData, viewAccountDetailLoading } = useSelector(
    (state) => state.verify,
  );

  const { editBeneficiaryData } = useSelector(
    (state) => state.beneCreateAccount,
  );
  const { services, isLoading } = useSelector((state) => state.refreshToken);
  useEffect(() => {
    const fetchContactData = async () => {
      let response = await dispatch(viewAccountDetail({ id: id }));
      if (response?.error?.message === "Request failed with status code 404") {
        navigate("*");
      }
    };
    fetchContactData();
  }, [dispatch, id, navigate]);

  const handleBack = () => {
    if (!nextButtonEnabled) {
      setOpenEditContactPop(true);
    } else {
      navigate(-1);
    }
  };

  const handleRadioBtn = (event) => {
    console.log(event.target.value);
    setSelectedValue(event.target.value);
    setSelectedRadioValue(event.target.value);
    handleUpdateLegalName(event.target.value);
  };
  const handleDivBtn = (value) => {
    setSelectedValue(value);
    setSelectedRadioValue(value);
    handleUpdateLegalName(value);
  };

  useEffect(() => {
    if (!viewAccountDetailLoading && viewAccountDetailData?.status === true) {
      const beneficiaryData = viewAccountDetailData?.beneficiary_accounts[0];

      if (beneficiaryData) {
        setPayload((prevPayload) => ({
          ...prevPayload,
          contact_no: beneficiaryData.contact_no,
          email_id: beneficiaryData.email_id,
          account_name: beneficiaryData.name,
          legalName: beneficiaryData.pan_legal_name,
        }));
      }
      if (beneficiaryData?.pan_legal_name === beneficiaryData?.name) {
        setSelectedValue("legalname");
        setSelectedRadioValue("legalname");
      } else {
        setSelectedValue("customname");
        setSelectedRadioValue("customname");
      }
    }
  }, [viewAccountDetailData, viewAccountDetailLoading, dispatch]);

  useEffect(() => {
    setContactNumberValidation(
      Validation.allowedContactNum(payload.contact_no),
    );
    setEmailValidation(Validation.allowedEmail(payload.email_id));
  }, [payload.contact_no, payload.email_id]);

  const emailRegex = /^[\w-.]+@([\w-]+\.)+[\w-]+$/;

  const modifyValue = (type, value) => {
    if (type === "name") {
      return value?.replace(/(\w)(\w*)/g, function (g1, g2) {
        return g1.toUpperCase() + g2.toLowerCase();
      });
    } else if (type === "gstin") {
      return value?.toUpperCase();
    } else if (type === "account_name") {
      return value;
    } else {
      return value.trim();
    }
  };

  const allowedValue = (name, value) => {
    if (name === "contact_no") return Validation.allowedContactNum(value);
    if (name === "email_id") return Validation.allowedEmail(value);

    return true;
  };

  const validateAndRecordError = (name, value) => {
    let errors = { ...customErrors };
    if (name === "email_id")
      errors = Validation.validateEmail(name, value, errors);
    if (name === "contact_no")
      errors = Validation.validateContactNum(name, value, errors);
    if (name === "account_name")
      errors = Validation.validateAccountName(name, value, errors);
    setCustomErrors(errors);
  };

  const checkAllValidations = () => {
    return contactNumberValidation && emailValidation;
  };

  const handleUpdateLegalName = (value) => {
    const beneficiaryData = viewAccountDetailData?.beneficiary_accounts?.[0];

    setPayload((prevPayload) => {
      if (value === "legalname") {
        return {
          ...prevPayload,
          account_name: beneficiaryData?.pan_legal_name || "",
        };
      }

      if (value === "username") {
        return {
          ...prevPayload,
          account_name: payload.userName,
        };
      }

      if (value === "customname") {
        const keepCurrent =
          prevPayload.account_name &&
          prevPayload.account_name.trim().length >
            GlobalConfiguration.lengthCheckZero &&
          prevPayload.account_name.trim().toLowerCase() !==
            (beneficiaryData?.pan_legal_name || "").trim().toLowerCase();

        return {
          ...prevPayload,
          account_name: keepCurrent
            ? prevPayload.account_name
            : beneficiaryData?.name || "",
        };
      }

      return prevPayload;
    });
  };

  useEffect(() => {
    if (!viewAccountDetailLoading && viewAccountDetailData?.status === true) {
      const beneficiaryData = viewAccountDetailData?.beneficiary_accounts[0];
      if (
        beneficiaryData?.contact_no !== payload.contact_no ||
        beneficiaryData?.email_id !== payload.email_id.toLowerCase() ||
        (beneficiaryData?.name.trim() !== payload.account_name.trim() &&
          payload.account_name.length !== GlobalConfiguration.lengthCheckZero)
      ) {
        if (
          !(
            checkAllValidations() &&
            payload.email_id?.length !== GlobalConfiguration.lengthCheckZero
          ) ||
          !(
            checkAllValidations() &&
            payload.contact_no?.length !== GlobalConfiguration.lengthCheckZero
          ) ||
          !payload.account_name.trim().length >
            GlobalConfiguration.lengthCheckZero
        ) {
          setNextButtonEnabled(true);
        } else {
          setNextButtonEnabled(false);
        }
      } else {
        setNextButtonEnabled(true);
      }
    }
  }, [payload.account_name, payload.contact_no, payload.email_id]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    const newValue = modifyValue(
      name,
      name !== "account_name" ? value.replace(/[^a-zA-Z0-9@.]/g, "") : value,
    );

    if (allowedValue(name, value)) {
      validateAndRecordError(name, newValue);
      setPayload((prevState) => ({
        ...prevState,
        [name]: newValue,
      }));

      if (
        value.trim() === "" &&
        value.length === GlobalConfiguration.lengthCheckOne
      ) {
        return;
      }
      if (name === "contact_no") {
        if (
          name === "contact_no" &&
          (newValue.length === GlobalConfiguration.lengthCheckZero ||
            newValue.length < GlobalConfiguration.panLength)
        ) {
          setContactNumberValidation(false);
        } else {
          setContactNumberValidation(true);
        }
      }
      if (name === "email_id") {
        if (
          name === "email_id" &&
          (newValue.length === GlobalConfiguration.lengthCheckZero ||
            !emailRegex.test(newValue))
        ) {
          setEmailValidation(false);
        } else {
          setEmailValidation(true);
        }
      }
      if (name === "account_name") {
        if (
          name === "account_name" &&
          newValue.length === GlobalConfiguration.lengthCheckZero
        ) {
          setAccountNameValidation(false);
        } else {
          setAccountNameValidation(true);
        }
        if (
          newValue ===
          viewAccountDetailData?.beneficiary_accounts[0]?.pan_legal_name
        ) {
          setSelectedValue("legalname");
          setSelectedRadioValue("legalname");
        }
      }
    }
  };

  useEffect(() => {
    if (customErrors["contact_no"]) setContactNumberValidation(false);
    if (
      !customErrors["contact_no"] &&
      payload.contact_no?.length === GlobalConfiguration.panLength
    )
      setContactNumberValidation(true);
    if (customErrors["email_id"]) setEmailValidation(false);
    if (
      !customErrors["email_id"] &&
      payload.email_id?.length > GlobalConfiguration.lengthCheckZero &&
      emailRegex.test(payload.email_id)
    )
      setEmailValidation(true);
    if (customErrors["account_name"]) setAccountNameValidation(false);
    if (
      !customErrors["account_name"] &&
      payload.account_name.length > GlobalConfiguration.lengthCheckZero
    )
      setAccountNameValidation(true);
  }, [customErrors]);

  useEffect(() => {
    if (editBeneficiaryData?.status === true) {
      navigate(
        `/field_force_account_dashboard/field_force_account_view_all/field_force_account_detail_page/account_details_success/${id}`,
      );
    }
  }, [editBeneficiaryData]);

  useEffect(() => {}, []);

  useEffect(() => {
    if (!isLoading && services != null) {
      if (services?.includes("BUAccount") || services?.includes("Admin")) {
      } else {
        navigate("/feature_not_assigned", {
          state: { unavailableService: "BUAccount" },
        });
      }
    }
  }, [services, isLoading]);

  const dataArray = [
    {
      previousText: "Cancel",
      nextText: "Update",
      stepperText: "Name, contact details, linked user, transaction limit",
      previousEnableBgColor: "var(--primary-nav-act)",
      nextEnableBgColor: "var(--positive-act)",
      nextDisableBgColor: "var(--text-disabled)",
      nextIsEnabled: true,
      nextHoverOption: "black",
    },
  ];

  const handleUpdateAccount2 = () => {
    dispatch(
      editBeneficiary({
        id: id,
        email: payload?.email_id?.toLowerCase(),
        contact_no: payload.contact_no,
        name: payload?.account_name,
        navigate,
      }),
    );
  };

  const handleConfirm = () => {
    navigate(
      `/field_force_account_dashboard/field_force_account_view_all/field_force_account_detail_page/${id}`,
    );
  };

  const handleAmountChange = (input) => {
    const { name, value } = input?.target ? input.target : input;

    const trimmedValue = value?.toString()?.trim() ?? "";

    if (!trimmedValue) {
      setPayload((prev) => ({
        ...prev,
        amount: "",
      }));
      // props?.setShowRupeeSymbol(false);
      return;
    }

    if (trimmedValue[GlobalConfiguration.lengthCheckZero] === "0") return;

    const numericValue = trimmedValue.replace(/[^0-9.]/g, "");

    if (
      name === "amount" &&
      (allowedValue(numericValue) || !numericValue.length)
    ) {
      if (Number(numericValue) === GlobalConfiguration) {
        setSelectedValueAmount("defaultAmount");
      } else {
        setSelectedValueAmount("customAmount");
      }
      setPayload((prev) => ({
        ...prev,
        amount: numericValue,
      }));

      // props?.setShowRupeeSymbol(numericValue.trim() !== "");
    }
  };

  const handleAutofill = () => {
    setPayload((prev) => ({
      ...prev,
      amount: 10000,
    }));
  };

  const handleDivBtnAmount = (value) => {
    setSelectedValueAmount(value);
    if (value === "customAmount") {
    } else if (value === "defaultAmount") {
      handleAutofill();
    }
  };

  const handleRadioBtnAmount = (event) => {
    setSelectedValueAmount(event.target.value);
    if (event.target.value === "customAmount") {
    } else if (event.target.value === "defaultAmount") {
      handleAutofill();
    }
  };
  return (
    <>
      <div className=" bg-primary-bg flex overflow-y-hidden flex-col h-full-height">
        <div
          className="max-w-tab-width-normal  w-full flex flex-col justify-start items-center mx-auto my-margin-base"
          style={{
            overflow: !nextButtonEnabled && openEditContactPop ? "" : "",
          }}
        >
          {!nextButtonEnabled && openEditContactPop && (
            <div className="fixed top-top-base left-left-base w-width-full h-height-full flex items-center bg-PopUp-BackDrop justify-center z-z-index-modal bg-opacity-dark-opacity">
              <SmallPopup
                headerTitle={"Are you sure you want to leave this page?"}
                headerFontWeight="semibold"
                headerFontColor="text-primary"
                textSize="font-md"
                subtext="Leaving this page will exit you from current flow."
                btnOneText="Cancel"
                btnOneBtnType="button"
                btnOneEnabledBgColor="transparent"
                btnOneHandleFunction={() => setOpenEditContactPop(false)}
                btnOneOutLineColor="var(--text-primary)"
                btnOneEnabledTextColor="var(--text-primary)"
                btnOneIsDisabled={false}
                btnOneHoverOption="white"
                btnTwoText="Leave"
                btnTwoBtnType="button"
                btnTwoHandleFunction={handleConfirm}
                btnTwoEnabledBgColor="var(--text-primary)"
                btnTwoEnabledTextColor="var(--primary-bg)"
                btnTwoIsDisabled={false}
                btnTwoHoverOption="black"
              />
            </div>
          )}
          <div className="hidden Qsmd:block min-h-navbar-breadcrumb-height"></div>
          <div className=" Qmd:h-stepper-height h-auto test-div justify-center items-end bottom-bottom-base Qsmd:flex hidden Qsmd:relative w-width-full z-z-index-header">
            <PrimaryStepper
              activeStep={0}
              handleForwardAction={handleUpdateAccount2}
              handleBackwardAction={handleBack}
              dataArray={dataArray}
            />
          </div>
          <div className=" bg-primary-nav mt-margin-base fixed top-top-base left-left-base w-full z-z-index-header">
            <TopNavComponent
              isFormattingNotRequired
              topNavHeader={"Field force account"}
              topNavSubText="Account details"
              handleBack={handleBack}
            />

            <div
              className={`h-mobile-create-header ${
                nextButtonEnabled
                  ? "bg-positive-act cursor-pointer"
                  : "bg-text-disabled cursor-not-allowed"
              } fixed bottom-bottom-base w-width-full text-text-primary items-center justify-center flex font-semibold z-z-index-modal Qsmd:hidden`}
              onClick={nextButtonEnabled ? handleUpdateAccount2 : undefined}
            >
              Update
            </div>
          </div>
          <div className="h-navbar-height block Qmd:hidden"></div>
        </div>

        <div className="w-full h-full overflow-y-scroll pb-padding-md no-scrollbar">
          <div className="h-navbar-breadcrumb-height hidden Qmd:block"></div>
          <div className="Qsmd:max-w-max-content-width max-w-full w-full mx-auto flex Qsmd:flex-row flex-col gap-gap-md px-padding-md Qsmd:px-padding-base pt-padding-md Qsmd:pt-padding-base">
            <div className="flex flex-col w-full gap-gap-md">
              <div>
                <AccountName
                  handleChange={handleChange}
                  accountNameValidation={accountNameValidation}
                  accountName={payload.account_name}
                  selectedValue={selectedValue}
                  handleDivBtn={handleDivBtn}
                  handleRadioBtn={handleRadioBtn}
                  selectedRadioValue={selectedRadioValue}
                  legalName={payload?.legalName}
                  type={"user"}
                  userName={payload.userName}
                />
              </div>
              <div>
                <ContactDetails
                  handleChange={handleChange}
                  contactNumberValidation={contactNumberValidation}
                  emailValidation={emailValidation}
                  contactNumber={payload.contact_no}
                  emailId={payload.email_id}
                  selectedValue={selectedValue}
                />
              </div>
            </div>
            <div className="flex flex-col w-full gap-gap-md">
              <div>
                <LinkEntityCard
                  payload={payload}
                  setPayload={setPayload}
                  selectedValue={selectedValue}
                  headerTitle="User view all"
                  redirectPath="/settings/user_view_all"
                  flow="fieldforceaccountcreate"
                  title="User"
                  description="Linked user will be able to create field force requests."
                  buttonText="Select user to link"
                />
              </div>
              <div>
                <TransactionLimit
                  // isPreview={true}
                  title={TEXT?.TRANSFER_AMOUNT}
                  amount={payload.amount}
                  // copyData={copyData}
                  onAmountChange={(val) =>
                    handleAmountChange({ name: "amount", value: val })
                  }
                  // onPasteApplied={() =>
                  //   setCopyData({ title: "", data_type: "", value: "" })
                  // }
                  isPreview={false}
                  CustomamountRequired={true}
                  handleDivBtn={handleDivBtnAmount}
                  selectedRadioValue={selectedValueAmount}
                  handleRadioBtn={handleRadioBtnAmount}
                />
              </div>
            </div>
            <div className="block Qsmd:hidden mt-[var(--stepper-gap-between)]"></div>
          </div>
        </div>
      </div>
    </>
  );
};

export default FieldForceEditContact;
